import {Component, Inject, Input, PLATFORM_ID} from "@angular/core";
import {TranslocoService} from "@ngneat/transloco";
import {localizedDateString} from "@utility";
import {isPlatformBrowser} from "@angular/common";

@Component({
    selector: 'app-event-date-display',
    templateUrl: './event-date-display.component.html',
    styleUrls: ['./event-date-display.component.scss'],
    standalone: false,
})
export class EventDateDisplayComponent {
  @Input() start?: Date | undefined;
  @Input() end?: Date | undefined;
  @Input() displayDay: boolean = true;
  @Input() showIcon: boolean = false;

  isBrowser = false;
  constructor(private translocoService: TranslocoService, @Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
   this.isBrowser = isPlatformBrowser(this.platformId);
  }

  checkSameDate(): boolean {
    if (this.start && this.end) {
      const startDate = new Date(this.start);
      const endDate = new Date(this.end);
      return startDate < endDate && (
        startDate.getDate() !== endDate.getDate() ||
        startDate.getMonth() !== endDate.getMonth() ||
        startDate.getFullYear() !== endDate.getFullYear()
      );
    }
    return false;
  }

  haveDifferentMonths(): boolean {
    if (this.start && this.end) {
      const startDate = new Date(this.start);
      const endDate = new Date(this.end);
      return startDate.getMonth() !== endDate.getMonth() || startDate.getFullYear() !== endDate.getFullYear();
    }
    return false;
  }

  haveDifferentYears(): boolean {
    if (this.start && this.end) {
      const startDate = new Date(this.start);
      const endDate = new Date(this.end);
      return startDate.getFullYear() !== endDate.getFullYear();
    }
    return false;
  }

  haveDifferentDaysOnly(): boolean {
    if (this.start && this.end) {
      const startDate = new Date(this.start);
      const endDate = new Date(this.end);
      return startDate.getDate() !== endDate.getDate()
        && startDate.getMonth() === endDate.getMonth()
        && startDate.getFullYear() === endDate.getFullYear();
    }
    return false;
  }

  formatDate(date: Date | string): string {
    const dateObj = new Date(date);
    const formatted = localizedDateString(dateObj, 'MMM', this.translocoService.getActiveLang());
    return formatted ? formatted.charAt(0).toUpperCase() + formatted.slice(1).toLowerCase() : '';
  }
}
